import axios from 'axios'
import { Toast } from 'vant'
import { errCodeMap } from './errorCode'

const request = axios.create({
  // baseURL: urlMap[process.env.NODE_ENV],
  baseURL: process.env.VUE_APP_API_HOST,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 60000
})

// 设置x-stream-id
function setXStreamId (headers) {
  let xStreamId = ''
  xStreamId = headers['x-stream-id']
  if (!xStreamId) {
    xStreamId = headers['X-Stream-Id']
  }
  if (xStreamId) {
    localStorage.setItem('x-stream-id', xStreamId)
  }
}

// 读取x-stream-id
export function getXStreamId () {
  let xStreamId = ''
  let storageObj = localStorage.getItem('x-stream-id')
  if (storageObj) {
    storageObj = JSON.parse(storageObj)
    const expired = new Date() > new Date(storageObj.expireTimeStamp)
    if (!expired) {
      xStreamId = storageObj.value
    } else {
      // localStorage.removeItem('x-stream-id')
    }
  }
  return xStreamId
}

// response 拦截器
request.interceptors.response.use(res => {
  if (res.config.url === '/user_auth/wxLoginByPhone') {
    setXStreamId(res.headers)
  }
  return res.data
}, error => {
  const code = errCodeMap[error.response?.data?.error_code] || ''
  if (code) {
    Toast(code)
  }
  // 特殊处理违规操作
  if (error.response?.data?.error_code === 0xA22006005) {
    Toast(error.response?.data?.error_msg)
  }
  return error
})

export default request
